import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import ExternalLayout from '../../layout/External'
import { AUTH_USER_THIRDSIGNUP } from '../../redux/actions/actionTypes'

const RegisterThird = () => {
  const countries = [{ text: 'Venezuela', value: 'ven' }]

  const states = [{ text: 'Zulia', value: 'zl' }]

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const form = useForm()

  const history = useHistory()

  const dispatch = useDispatch()

  const onSubmit = (values) => {
    dispatch({
      type: AUTH_USER_THIRDSIGNUP,
      payload: {
        ...values,
        country: countries.find(country => country.value === values.country)?.text,
        state: states.find(state => state.value === values.state)?.text
      },
    })

    history.push('/registro_cuarto')
  }

  // useEffect(() => {
  //   form.
  // }, [])

  return (
    <ExternalLayout>
      <h1 className="font-bold text-2xl text-coolGray-900 mb-2 dark:text-white">
        Información de tu empresa
      </h1>

      <p
        className="font-normal text-sm mb-2 text-primary-700 dark:text-primary-200"
        style={{ opacity: 0.5 }}
      >
        Paso 3 de 5
      </p>

      <div className="w-96">
        <p className="font-normal text-gray-400 text-sm mb-2">
          Brindanos información para personalizar tu cuenta{' '}
        </p>
      </div>

      <Form form={form} onSubmit={onSubmit} classes={`gap-x-3 max-w-sm`}>
        <FormItem
          classes="col-span-12 my-2"
          name="businessName"
          rules={{ required: 'Ingrese su nombre' }}
        >
          <InputText label="Nombre de tu negocio" isUpperValue={false} />
        </FormItem>

        <FormItem classes="col-span-12 my-2" name="businessSocial">
          <InputText label="Razón Social (opcional)" isUpperValue={false} />
        </FormItem>

        <FormItem
          name="document.documentType"
          defaultValue={docs[0]}
          rules={{ required: 'Es necesario el campo' }}
          classes="col-span-2 my-2"
        >
          <Select options={docs} label="Tipo" />
        </FormItem>

        <FormItem classes="col-span-10 my-2" name="document.document">
          <InputText label="Rif (opcional)" isUpperValue={false} />
        </FormItem>

        <FormItem classes="col-span-12 my-2" name="address">
          <InputText label="Direccion fiscal (opcional)" isUpperValue={false} />
        </FormItem>

        <FormItem
          classes="col-span-12 my-2"
          name="country"
          defaultValue={countries[0]}
        >
          <Select options={countries} label="País" disabled={true} />
        </FormItem>

        <FormItem
          classes="col-span-12 my-2"
          name="state"
          defaultValue={states[0]}
        >
          <Select options={states} label="Estado" />
        </FormItem>

        <FormItem
          classes="col-span-12 my-2"
          name="city"
          rules={{ required: 'Ingrese su ciudad' }}
        >
          <InputText label="Ciudad" isUpperValue={false} />
        </FormItem>

        <FormItem classes="col-span-12 my-2" name="postalCode">
          <InputText label="Código postal (opcional)" isUpperValue={false} />
        </FormItem>

        <Button
          type="primary"
          classes="col-span-12 mt-6 font-semibold tracking-wide"
          htmlType="submit"
        >
          Continuar
        </Button>
      </Form>
    </ExternalLayout>
  )
}

export default RegisterThird
